<div class="pmd-editor-container">
	<div class="pmd-editor">
		<div  contenteditable="true" class="pmd-editor-editable-aria" id="custom-editor" #editor (paste)="handlePaste($event)" ></div>
		<div class="pmd-editor-attached-files">
			<div class="pmd-chip" *ngFor="let file of attachedFiles">
				<!-- <i class="material-icons md-dark pmd-icon-sm">mood</i> -->
				<a [href]="file.url" target="_blank">{{ file.name }}</a>
				<a class="pmd-chip-action" href="javascript:void(0);" (click)="removeFile(file)"><i class="material-icons">close</i></a>
			</div>
			<!-- <div *ngFor="let file of attachedFiles">
				<a [href]="file.url" target="_blank">{{ file.name }}</a>
				<button (click)="removeFile(file)">Remove</button>
			</div> -->
		</div>
	</div>
	
	<div class="pmd-editor-toolbar">
		<div class="btn-group">
			<button type="button" pmd-btn-flat pmd-btn-fab pmdRipple color="dark" theme="bootstrap4" container="body" pmdTooltip="Bold"
			placement="bottom" [ngClass]="{ 'active': isBold }" (click)="formatText('bold')" size="xs">
				<i class="material-icons md-dark pmd-icon-xs">format_bold</i>
			</button>
			<button type="button" pmd-btn-flat pmd-btn-fab pmdRipple color="dark" [ngClass]="{ 'active': isItalic }" container="body" theme="bootstrap4" pmdTooltip="Italic"
			placement="bottom" (click)="formatText('italic')" size="xs">
				<i class="material-icons md-dark pmd-icon-xs">format_italic</i>
			</button>
			<button type="button" pmd-btn-flat pmd-btn-fab pmdRipple color="dark" [ngClass]="{ 'active': isUnderline }" (click)="formatText('underline')" theme="bootstrap4" container="body" pmdTooltip="Underline"
			placement="bottom" size="xs">
				<i class="material-icons md-dark pmd-icon-xs">format_underlined</i>
			</button>
		</div>
		<div class="btn-group">
			<button type="button" pmd-btn-flat pmd-btn-fab pmdRipple color="dark" [ngClass]="{ 'active': isInsertOrderedList }" theme="bootstrap4" container="body" pmdTooltip="Ordered List"
			placement="bottom" (click)="toggleList('insertOrderedList')" size="xs">
				<i class="material-icons md-dark pmd-icon-xs">format_list_numbered</i>
			</button>
			<button type="button" pmd-btn-flat pmd-btn-fab pmdRipple color="dark" [ngClass]="{ 'active': isInsertUnorderedList }" theme="bootstrap4" container="body" pmdTooltip="Bulleted List"
			placement="bottom" (click)="toggleList('insertUnorderedList')" size="xs">
				<i class="material-icons md-dark pmd-icon-xs">format_list_bulleted</i>
			</button>
		</div>
		<div class="btn-group">
			<button type="button" pmd-btn-flat pmd-btn-fab pmdRipple color="dark" theme="bootstrap4" container="body" pmdTooltip="Link"
			placement="bottom" (click)="insertLink()" size="xs">
				<i class="material-icons md-dark pmd-icon-xs">link</i>
			</button>
			<button type="button" pmd-btn-flat pmd-btn-fab pmdRipple color="dark" class="custom-file-input" theme="bootstrap4" container="body" pmdTooltip="Attachments"
			placement="bottom" size="xs">
				<span class="material-icons md-dark pmd-icon-xs">attach_file</span>
				<input type="file" (change)="attachFiles($event)" id="files"  accept="{{validation.allowedFileType}}"
					[(ngModel)]="fileInputValue" multiple/>
					<label for="files"> </label>
			</button>
		</div>
		<!-- <select (change)="selectHeadingLevel($event)">
			<option value="p">Paragraph</option>
			<option value="h1">Heading 1</option>
			<option value="h2">Heading 2</option>
		</select> -->
		<!-- <button (click)="setHeading(1)">Heading 1</button>
		<button (click)="setHeading(2)">Heading 2</button>
		<button (click)="setParagraph()">Paragraph</button> -->
	</div>
	
</div>
<div class="d-flex align-items-center">
	<small class="form-text text-muted d-flex align-items-center"><span class="material-icons-round md-dark pmd-icon-xs me-1">info_outline</span> Maximum 500 characters ({{supportDescriptionRemainingLength}} remaining)</small>
</div>
<div>
	<!-- <ng-select [(ngModel)]="selectedHeadingLevel" (mousedown)="preventDefault($event)">
		<ng-option value="p">Paragraph</ng-option>
		<ng-option value="h1">Heading 1</ng-option>
		<ng-option value="h2">Heading 2</ng-option>
	</ng-select> -->
	<!-- <button type="button" (click)="getHtmlContent()">Get HTML Content</button> -->
	<!-- <div [innerHTML]="editorContent"></div> -->

</div>